import {
  Box,
  ParagraphText,
  StackLayout,
  TextAction,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { EXTERNAL_LINKS } from 'common/links';

export const Disclaimer = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout spacing="$two">
      <Box css={{ width: '100%' }}>
        <ParagraphText css={{ typography: '$caption', display: 'inline' }}>
          {formatMessage({ id: 'STR_FOOTER_DISCLAIMER' })}{' '}
        </ParagraphText>
        <TextAction
          href={EXTERNAL_LINKS.DISCLAIMER}
          target="_blank"
          rel="noopener noreferrer"
          css={{
            typography: '$caption',
            textDecoration: 'underline',
          }}
        >
          {formatMessage({ id: 'STR_FOOTER_DISCLAIMER_FULL_LINK' })}
        </TextAction>
      </Box>

      <ParagraphText css={{ typography: '$caption', fontWeight: '500' }}>
        {formatMessage({ id: 'STR_FOOTER_COPYRIGHT' })}
      </ParagraphText>
    </StackLayout>
  );
};
